module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-3.f8078e99.mp3";